import { CREATE_GLOBAL_NOTES_SUCCESS, GET_CLIENT_NOTES_SUCCESS, GET_GLOBAL_NOTES_SUCCESS, GET_NOTE_BY_ID_SUCCESS } from './note.type';

const initialState = {
    notes: [],
    noteById: {}
};

export const noteReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_GLOBAL_NOTES_SUCCESS:
            return {
                ...state,
                notes: action.payload,
            };

        case GET_CLIENT_NOTES_SUCCESS:
            return {
                ...state,
                clientNotes: action.payload,
            };

        case GET_NOTE_BY_ID_SUCCESS:
            return {
                ...state,
                noteById: action.payload,
            };

        // case  CREATE_GLOBAL_NOTES_SUCCESS:
        //     return {
        //         ...state,
        //         notes: [action.payload, ...state.notes],
        //     };
        default:
            return state;
    }
};
